import createTheme from 'spectacle/lib/themes/default';

const theme = createTheme(
  {
    primary: 'white',
    secondary: '#0168b8',
    tertiary: '#1F2022',
    quartenary: '#e53b2c',
  },
  {
    primary: 'Montserrat',
    secondary: 'Helvetica',
  }
)

export default theme

